import Nav from "./../Page/Share/Nav/Nav";
const Post7 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Apiphen Packaging Design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/631218159141967.639a24e223626.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/515e10159141967.639a24e222934.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/a3040b159141967.639a1ceed4cce.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/56c920159141967.639a220825606.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/6d70f7159141967.639a2098b45cc.jpg" alt="" />

          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post7;
